import React, { PropsWithChildren } from 'react';

type Props = PropsWithChildren;

export default function DashboardSubheader({ children }: Props) {
  return (
    <h6 className="high-emphasis-text font-semibold capitalize">{children}</h6>
  );
}
